import $ from "jquery";
import "./../styles/main.scss";
require('./woocommerce/Global');
require('./helpers/CookieConsent');
require("./helpers/SliderWrapper");
require("./helpers/CarouselWrapper");
require("jquery.scrollto");
import AOS from "aos";
require("./helpers/plyr");
$(document).ready(function () {
    $("#searchbox").on("click", "a.close", function (e) {
        e.preventDefault();
        $("#searchbox").removeClass("visible");
    });
    $(".opensearch").on("click", function (e) {
        e.preventDefault();
        $("#searchbox").addClass("visible");
        $("#searchbox").find("input").focus();
    });
    $("body").on("click", "a[data-goto]", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    AOS.init({
        disable: 'mobile'
    });
    setTimeout(function () { AOS.refresh(); }, 500);
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    if ($('.woocommerce-variation.single_variation').length) {
        $('.woocommerce-variation.single_variation').detach().prependTo(".variations_form.cart");
    }
    if ($(".price_simple_product").length) {
        $('.add-to-cart-wrapper form.cart').prepend($(".price_simple_product").detach());
    }
    if ($("#plyrplayer").length) {
        var player = new Plyr('#plyrplayer');
    }
    $('aside.categories-banner + .switcher').on("click", function (e) {
        e.preventDefault();
        $('aside.categories-banner').toggleClass("open");
    });
    $('#menu-switcher').on("click", "a", function (e) {
        e.preventDefault();
        $('#menu-switcher').toggleClass("open");
        $('#main-header > .menu').toggleClass("open");
        $("#main-header").toggleClass("menu-opened");
    });
    var breakpoint = 350;
    $(window).scroll(function () {
        if ($(window).scrollTop() > breakpoint) {
            $('#main-header').addClass('small-logo');
        }
        if ($(window).scrollTop() < breakpoint) {
            $('#main-header').removeClass('small-logo');
        }
    });
    $(window).trigger("scroll");
    if ($(".pop-up").length) {
        $(".pop-up").on("click", ".close, .overlay", function (e) {
            e.preventDefault();
            $('.pop-up').fadeOut(300, function () {
                if ($('.products-wrapper-popup').length) {
                    setTimeout(function () {
                        $('.products-wrapper-popup').hide();
                    }, 500);
                }
            });
        });
    }
    if ($('.products-viewer').length) {
        $('body').on("click", ".products-viewer", function (e) {
            e.preventDefault();
            $($(e.currentTarget).attr("href")).show();
            $('#popup-product').fadeIn(300);
        });
    }
    $('.remove-wishlist').on("click", function (e) {
        e.preventDefault();
        if (confirm("Etes-vous sur de vouloir supprimer cet élément ?")) {
            $.get($(e.currentTarget).attr("href"), function () {
                // $(e.currentTarget).parents(".woocommerce-cart-form__cart-item.cart_item").fadeOut();
                document.location.reload();
            });
        }
    });
    $("body").on("click", ".disabled", function (e) {
        e.preventDefault();
    });
    $("body").on("click", ".ff-add-to-cart:not(.disabled)", function (e) {
        e.preventDefault();
        $(e.currentTarget).addClass("disabled");
        var href = $(e.currentTarget).attr("href");
        $.get(href, function (data) {
            var htmlNode = $(data);
            $("body").find(".Cart.cart-mini-contents").html(htmlNode.find(".Cart.cart-mini-contents").html());
            $("#basket-popup").fadeIn(500);
            setTimeout(function () {
                $("#basket-popup").fadeOut(500);
                $(e.currentTarget).removeClass("disabled");
            }, 3000);
        });
    });
    $("body").on("click", ".add-to-wishlist:not(.disabled)", function (e) {
        e.preventDefault();
        $(e.currentTarget).addClass("disabled");
        var href = $(e.currentTarget).attr("href");
        $.get(href, function () {
            $("#wishlist-popup").fadeIn(500);
            setTimeout(function () {
                $(e.currentTarget).removeClass("disabled");
                if ($("body").hasClass("user-logged-in")) {
                    $(e.currentTarget).addClass("added");
                    $("#wishlist-popup").fadeOut(500);
                }
            }, 3000);
        });
    });
    if ($('a[href="#meeting"]').length) {
        $('body').on("click", 'a[href="#meeting"]', function (e) {
            e.preventDefault();
            $('#meeting-popup').fadeIn(300);
        });
    }
    if ($('a[href="#typeform"]').length) {
        $('body').on("click", 'a[href="#typeform"]', function (e) {
            e.preventDefault();
            var node = $(e.currentTarget).attr("href");
            if ($(node).length) {
                var minus = 0;
                if ($(window).width() < 560) {
                    minus = -200;
                }
                var posY = $(node).offset().top - $("#main-header").height() - minus;
                if (posY >= 0) {
                    $.scrollTo(posY, 400);
                }
            }
        });
    }
    if (location.hash !== void 0) {
        var node = location.hash;
        if (node != "") {
            var minus = $(window).width() < 600 ? 30 : 100;
            var minus = 0;
            var posY = $(node).offset().top - $("#main-header").height() - minus;
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    }
    if ($('.single-service').length) {
        var elements_1 = $("#work").find(".elements");
        $("#work").on("click", ".navigation a", function (e) {
            e.preventDefault();
            $("#work .navigation .current").removeClass("current");
            $(e.currentTarget).addClass("current");
            var index = $(e.currentTarget).index();
            elements_1.css({ height: elements_1.children("li:visible").height() });
            var next = elements_1.children("li:eq(" + (index) + ")");
            elements_1.children("li:visible").fadeOut(300, function () {
                var posY = elements_1.offset().top - $("#main-header").height() - 50;
                $.scrollTo(posY, 400);
                next.fadeIn(function () {
                    elements_1.animate({ height: next.height() }, 300);
                });
            });
        });
    }
});
